import script from "./PhysicianScheduleAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./PhysicianScheduleAdmin.vue?vue&type=script&setup=true&lang=js"

import "./PhysicianScheduleAdmin.vue?vue&type=style&index=0&id=ae374b7a&lang=css"
import "./PhysicianScheduleAdmin.vue?vue&type=style&index=1&id=ae374b7a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae374b7a"]])

export default __exports__